// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1BzZw","balanceDisclaimer":"posDashboard_balanceDisclaimer__3hDNs"};